import { connect } from 'react-redux';

import {
  GET_BOOKING_REVIEW_DETAIL,
  POST_FEEDBACK_BOOKING_REVIEW,
  UPDATE_BOOKING_REVIEW,
  DELETE_BOOKING_REVIEW,
  UPDATE_FEEDBACK_BOOKING_REVIEW,
  DELETE_FEEDBACK_BOOKING_REVIEW,
} from 'store/booking-review/actionTypes';

import ReviewDetail from './ReviewDetail';

const mapStateToProps = (state) => ({
  isLoadingGetBookingReviewDetail: state.BookingReview.isLoadingGetBookingReviewDetail,
  isLoadingPostFeedbackBookingReview: state.BookingReview.isLoadingPostFeedbackBookingReview,
  isLoadingUpdateBookingReview: state.BookingReview.isLoadingUpdateBookingReview,
  isLoadingDeleteBookingReview: state.BookingReview.isLoadingDeleteBookingReview,
  isLoadingUpdateFeedbackBookingReview:
    state.BookingReview.isLoadingUpdateFeedbackBookingReview,
  isLoadingDeleteFeedbackBookingReview:
    state.BookingReview.isLoadingDeleteFeedbackBookingReview,
  bookingReviewDetail: state.BookingReview.bookingReviewDetail,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetBookingReviewList: (payload) => dispatch({
    type: GET_BOOKING_REVIEW_DETAIL,
    payload,
  }),

  actionPostFeedbackBookingReview: (payload) => dispatch({
    type: POST_FEEDBACK_BOOKING_REVIEW,
    payload,
  }),

  actionUpdateBookingReview: (payload) => dispatch({
    type: UPDATE_BOOKING_REVIEW,
    payload,
  }),

  actionDeleteBookingReview: (payload) => dispatch({
    type: DELETE_BOOKING_REVIEW,
    payload,
  }),

  actionUpdateFeedbackBookingReview: (payload) => dispatch({
    type: UPDATE_FEEDBACK_BOOKING_REVIEW,
    payload,
  }),

  actionDeleteFeedbackBookingReview: (payload) => dispatch({
    type: DELETE_FEEDBACK_BOOKING_REVIEW,
    payload,
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReviewDetail);
